<template>
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <div class="d-flex">
          <router-link to="/meetings"><div>
            <h3 v-if="!$parent.meeting_view" class="card-title"><i class="ti-calendar"></i> {{ $t('Upcoming meetings') }}</h3>
            <h3 v-else class="card-title"><i class="ti-calendar"></i> {{ $t('Meetings') }}</h3>
          </div></router-link>
          <div class="ml-auto">
            <button class="btn btn-sm btn-rounded btn-info overrule" v-on:click="planmeeting"><i class="ti-plus"></i> {{ $t('Plan meeting')}}</button>
          </div>
        </div>
        <div class="table-responsive m-t-20" v-if="meetingData !== null">
          <table class="table vm no-th-brd pro-of-month">
            <tbody>
            <tr v-for="meeting in meetingData">
              <td>
                <h6 class="font-bold" v-html="$options.filters.formatDateDay(meeting.date_start, this)"></h6><small class="text-muted">{{ meeting.location }}</small></td>
              <td>
                <router-link :to="'/meeting/' + meeting.uid"><h5 class="font-bold" v-html="meeting.name"></h5><small class="text-muted">{{ $t(meeting.meeting_type) }}</small></router-link>
              </td>
              <td>
                <router-link class="btn-rounded btn-sm btn btn-secondary overrule" v-if="meeting.plannable === '1'" :to="/planmeeting/ + meeting.uid">{{ $t("Plan") }}</router-link>
              </td>
              <td>
                <span class="pull-right">
                  <router-link class="overrule" :to="'/meeting/' + meeting.uid">{{ $t("Details") }}</router-link>
                </span>
              </td>
            </tr>
            </tbody>
          </table>
          <h4 class="text-muted" v-show="meetingData.length < 1">
            {{ $t("No upcoming meetings scheduled") }}
          </h4>
          <span class="text-info"><i class="ti-plus"></i>
            <router-link class="overrule" to="/meetings">{{ $t('All meetings') }}</router-link></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import apiHelper from '../mixins/APIHelper';

    export default {
      props: {
        "data": {
          default: null
        }
      },
      name: "meeting-widget",
      data: function () {
        return {
          meetingData: this.data
        }
      },
      created() {
        if (this.meetingData === null) {
          this.getMeetings();
        }
      },
      methods: {
        // Function to get the meeting data from the server
        getMeetings: function() {
          let vm = this;
          let userID = "XvUNTZ2xwEqE";
          let data = {
            'limit': 4,
            'history': 0
          };
          apiHelper.getResource("/api/user/" + userID + "/meetings", data)
            .then((data) => {
              vm.meetingData = data;
            });
        },
        planmeeting: function () {
          this.$router.push("/planmeeting");
        }
      },
      filters: {
        dateFormat: function (value) {

          return value;
        },
        htmlFormat: function (value) {
          return sanitizeHtml(value);
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/MeetingWidget.vue